import React from 'react';
import BeamRankListItem from '../BeamRankListItem/BeamRankListItem';
import './BeamRankList.css';

const BeamRankList = (props) => {
  let beamRankListItems = null;

  if (props.beamrank) {
    beamRankListItems = props.beamrank.map((entry, index) => {
      return <BeamRankListItem key={index} index={index} entry={entry} {...props} />;
    });
    
    // Add the custom beam item
    beamRankListItems.push(
      <BeamRankListItem 
        key={3} 
        index={3} 
        entry={props.customBeamData || null} 
        {...props} 
        mode="custom" 
        onCustomBeamSet={(customBeamData) => {
          // Update the parent component with the custom beam data
          if (props.setCustomAzEl) {
            props.setCustomAzEl({
              az: customBeamData.az,
              el: customBeamData.el,
              data: customBeamData
            });
          }
        }}
      />
    );
  }

  return (
    <div role="listbox" className="BeamRankList_Container">
      {beamRankListItems}
    </div>
  );
};

export default BeamRankList;
